<template>
  <ul class="sticky chat-feed-max-w mx-auto inset-0 z-10 flex h-full flex-col-reverse overflow-y-auto p-6 will-change-scroll">
    <li class="mt-2 flex animate-pulse items-center">
      <div class="h-12 w-12 rounded-full bg-bg-base-bg4" />
      <div class="ml-2">
        <div class="mb-2 h-4 w-44 rounded-8 bg-bg-base-bg4" />
        <div class="h-12 w-40 rounded-8 bg-bg-base-bg4" />
      </div>
    </li>
    <li class="mt-2 flex animate-pulse items-center justify-end">
      <div class="flex flex-col items-end">
        <div class="mb-2 h-4 w-8 rounded-8 bg-bg-base-bg4" />
        <div class="h-12 w-40 rounded-8 bg-bg-base-bg4" />
      </div>
    </li>
    <li class="mt-2 flex animate-pulse items-center">
      <div class="h-12 w-12 rounded-full bg-bg-base-bg4" />
      <div class="ml-2">
        <div class="mb-2 h-4 w-44 rounded-8 bg-bg-base-bg4" />
        <div class="h-12 w-40 rounded-8 bg-bg-base-bg4" />
      </div>
    </li>
    <li class="mt-2 flex animate-pulse items-center justify-end">
      <div class="flex flex-col items-end">
        <div class="mb-2 h-4 w-8 rounded-8 bg-bg-base-bg4" />
        <div class="h-12 w-40 rounded-8 bg-bg-base-bg4" />
      </div>
    </li>
    <li class="mt-2 flex animate-pulse items-center justify-end">
      <div class="flex flex-col items-end">
        <div class="mb-2 h-4 w-8 rounded-8 bg-bg-base-bg4" />
        <div class="h-12 w-40 rounded-8 bg-bg-base-bg4" />
      </div>
    </li>
    <li class="mt-2 flex animate-pulse items-center">
      <div class="h-12 w-12 rounded-full bg-bg-base-bg4" />
      <div class="ml-2">
        <div class="mb-2 h-4 w-44 rounded-8 bg-bg-base-bg4" />
        <div class="h-12 w-40 rounded-8 bg-bg-base-bg4" />
      </div>
    </li>
    <li class="mt-2 flex animate-pulse items-center">
      <div class="h-12 w-12 rounded-full bg-bg-base-bg4" />
      <div class="ml-2">
        <div class="mb-2 h-4 w-44 rounded-8 bg-bg-base-bg4" />
        <div class="h-12 w-40 rounded-8 bg-bg-base-bg4" />
      </div>
    </li>
    <li class="mt-2 flex animate-pulse items-center justify-end">
      <div class="flex flex-col items-end">
        <div class="mb-2 h-4 w-8 rounded-8 bg-bg-base-bg4" />
        <div class="h-12 w-40 rounded-8 bg-bg-base-bg4" />
      </div>
    </li>
    <li class="mt-2 flex animate-pulse items-center justify-end">
      <div class="flex flex-col items-end">
        <div class="mb-2 h-4 w-8 rounded-8 bg-bg-base-bg4" />
        <div class="h-12 w-40 rounded-8 bg-bg-base-bg4" />
      </div>
    </li>
  </ul>
</template>
